import { getSyncNotificationList } from '@/services/admin/sync-notifications';
import { SyncNotificationQuery } from '@/types/admin-sync-notification';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

export const useAdminSyncNotificationList = (query: SyncNotificationQuery) => {
  const { site } = useParams<{ site: string }>();
  const currentSite = site ?? 'medix';

  return useQuery({
    queryKey: ['sync-notifications', currentSite, query],
    queryFn: () => getSyncNotificationList(currentSite, query),
    select: res => res.data,
  });
};
